import {useRef} from 'react'
import { useLocation } from 'react-router-dom'
import {parseISO} from 'date-fns'

import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
import {NewRequest} from 'modules/requests'
import {Text, Button, Modal} from 'common/components'
import {useOpen} from 'common/hooks'
import {CheckActionsProps} from '..'

interface CopyRequestProps {
  request: any
}

export default function DeclinedRequestActions({
  role,
  request,
}: CheckActionsProps) {
  const {pathname} = useLocation()
  const isLoanRequest = (pathname.indexOf('/requests/loan/') > -1)
  const declinedRole =
    request.statusHistory?.[1].status === 'director-check'
      ? 'Director'
      : 'Lending manager'
  const declinedReason = request.statusHistory?.[0].reason || 'unknown'

  return (
    <div className={commonStyles.checkActions}>
      <Text size="xs">
        <Text as="span" weight="demiBold">
          {declinedRole}:
        </Text>{' '}
        {declinedReason}
      </Text>
      {(role.manager || role.coordinator) && !!isLoanRequest && <CopyRequest request={request} />}
    </div>
  )
}

const CopyRequest = ({request}: CopyRequestProps) => {
  const setNewRequest = useStore((state) => state.setNewRequest)
  const [isOpen, handleOpen, handleClose] = useOpen()
  const modalWrapRef = useRef()

  const handleCopy = () => {
    const {project} = request
    const newRequest = {
      brokerName          : request?.brokerName,
      brokerEmail         : request?.brokerEmail,
      brokerPhoneNumber   : request?.brokerPhoneNumber,
      borrowerName        : request?.borrowerName,
      borrowerEmail       : request?.borrowerEmail,
      borrowerPhoneNumber : request?.borrowerPhoneNumber,
      borrowerBackground  : request?.borrowerBackground,
      brokerHelp          : !!request?.brokerEmail,

      loanValueRequested  : request?.loanValueRequested,
      dates               : [parseISO(request.openDate), parseISO(request.maturityDate)],

      title       : project.title,
      address     : project.address,
      description : project.description,
      
      categories  : project.categories,
      units       : project.units,

      // region: project.region,
      // borrower: project.borrower.uuid,
      // brokerProfile: project.brokerProfile?.uuid,
    }
    setNewRequest(newRequest)
    handleOpen()
  }

  return (
    <>
      <Button onClick={handleCopy}>Copy to a new request</Button>
      <Modal
        open={isOpen}
        title="New request"
        wrapProps={{ref: modalWrapRef}}
        onCancel={handleClose}
      >
        <NewRequest modalWrapRef={modalWrapRef} onClose={handleClose} />
      </Modal>
    </>
  )
}
